/**
 * Coach-mark anchor keys (workbook v2.38) for the saved-Plan, edit-Plan and favourite-Plan lessons
 * of FLIP-386. Kept free of imports so components, cards and the lesson services can all name an
 * anchor without pulling each other in (the expanded-card view and CardExpandService would
 * otherwise import each other through the lesson service).
 */

/** UP03 (workbook v2.51): beside a Star Card in the saved hand. UP02 is retired and has no anchor. */
export const UP03_ANCHOR = "plan.star_card";
/** UP04: the bottom-right expand icon of a card in the active stack. */
export const UP04_ANCHOR = "plan.card_expand";
/** UP05: the flip icon on the expanded card - present only when the card has a back. */
export const UP05_ANCHOR = "plan.card_flip";
/** UP06: the eye icon above a day section. */
export const UP06_ANCHOR = "plan.section_visibility";
/** UP07 (workbook v2.51): one anchor per control of the saved hand's menu. UP07A (Back) is retired and has none. */
export const UP07B_ANCHOR = "plan.view_menu_favourite";
export const UP07C_ANCHOR = "plan.view_menu_zoom";
export const UP07D_ANCHOR = "plan.edit_button";
export const UP07E_ANCHOR = "plan.view_menu_reuse";
export const UP07F_ANCHOR = "plan.view_menu_delete";
/** UP07M and UP08 (v2.51): the top-right three-dot menu button of the hand. */
export const UP07M_ANCHOR = "plan.view_menu";
export const UP08_ANCHOR = UP07M_ANCHOR;
/** EP01: the Cancel and Save hand buttons at the bottom of the hand builder. */
export const EP01_ANCHOR = "plan.edit_actions";
/** FP01: the Favourite Plans section of the Plan landing page. */
export const FP01_ANCHOR = "plan.favourite_plans";
/** FP02: the View all control of the Favourite Plans section. */
export const FP02_ANCHOR = "plan.favourite_plans_view_all";
